import { buildEvent } from '../utils';

export const SEND_EVENT = buildEvent('send', 'SendEvent');
